import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/General/HeaderButton/headerButton.container"
    ).then((module) => ({
        default: module.HeaderButtonContainer
    }))
);
